export const LEGAL_DOCUMENT_SLUGS = [
    'kvkk-aydinlatma',
    'gizlilik-politikasi',
    'kullanim-kosullari',
    'acik-riza',
    'cerez-politikasi',
    /** Satış başvurusu formunun aydınlatma metni (kurum satışla açılır · Story B1). */
    'satis-basvurusu',
    /** Kurum hesabı aydınlatma metni (kurum hesabı · Story H5, V11). */
    'kurum-hesabi-aydinlatma',
];
//# sourceMappingURL=types.js.map